export default __webpack_public_path__ + "static/media/drivers1.1a3605eb.svg";